<template lang="pug">
el-dialog(
  :visible.sync="dialogVisible"
  :width="dialogWidth"
  class="custom-dialog-esqueci-senha"
  top="5vh"
  @close="resetForm"
  title="Esqueci minha senha"
  :close-on-click-modal="false"
)
  .login-cadastro__form
    .login-cadastro__form__group
      label(for="esqueci-senha") E-mail
      el-input(v-model="email" placeholder="Digite seu e-mail" type="email" id="esqueci-senha")
      div(v-if="emailError" class="error-message") {{ emailError }}
    .obs-alerta
      div <strong>Atenção:</strong> A senha atual será redefinida, <strong class="sublinhado">e uma nova senha</strong> será enviada para o e-mail informado.
      div Verifique sua caixa de entrada e a pasta de spam.
    .login-cadastro__form__group__button
      el-button(type="primary" plain @click="recuperar" :disabled="isButtonDisabled") Enviar nova senha
      el-button(type="text" @click="dialogVisible = false") Cancelar
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  data(){
    return{
      email: '',
      emailError: '',
      currentDialogWidth: this.calculateDialogWidth(),
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  computed: {
    ...mapGetters({
      getModalResetSenha: 'modais/getResetSenha'
    }),
    dialogVisible: {
      get(){
        return this.getModalResetSenha
      },
      set(newValue){
        this.setResetSenha(newValue)
      }
    },
    dialogWidth() {
      return this.currentDialogWidth;
    },
    isButtonDisabled() {
      return this.emailError !== '' || this.email === ''
    }
  },
  watch: {
    email(value) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailPattern.test(value)) {
        this.emailError = 'Por favor, insira um e-mail válido.'
      } else {
        this.emailError = ''
      }
    },
    dialogVisible(){
      if (this.dialogVisible) this.emailError = ''
    }
  },
  methods:{
    ...mapActions({
      recuperarSenha: 'auth/recuperarSenha'
    }),
    ...mapMutations({
      setLoading: 'globais/setLoading',
      setResetSenha: 'modais/setResetSenha',
    }),

    calculateDialogWidth() {
      return window.innerWidth < 576 ? '90%' : '490px'
    },
    handleResize() {
      this.currentDialogWidth = this.calculateDialogWidth()
    },

    recuperar(){
      if (!this.emailError) {
        this.setLoading(true)
        this.recuperarSenha({ email: this.email })
        .then(() => {
          this.setLoading(false)
          this.$message({
            message: 'Uma nova senha foi enviada para o E-mail informado.',
            type: 'success'
          })
          setTimeout(() => {
            this.dialogVisible = false
          }, 2000)
        })
        .catch(() => {
          this.setLoading(false)
          this.$message.error('Erro ao redefinir a senha')
        })
      }
    },
    resetForm() {
      this.email = ''
      this.emailError = ''
      this.setResetSenha(false)
    }
  }
}
</script>

<style lang="scss">
.custom-dialog-esqueci-senha {
background: rgba(0, 0, 0, .6);

  .el-dialog {
    border-radius: 10px;

    .el-dialog__header{
      padding: 20px;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 1px solid #bcb8b8;

      .el-dialog__headerbtn{
        top: 19px;

        i{
          font-size: 30px;
        }
      }
    }

    .el-dialog__body{
      padding: 20px;

      .login-cadastro__form{
        .obs-alerta {
          padding: 15px 20px;
          box-sizing: border-box;
          border: 1px solid #F79009;
          border-radius: 6px;
          color: #F79009;
          background: #FFFCF5;
          font-size: 13px;
          margin: 20px 0;
          word-break: break-word;

          & > div:first-child{
            margin-bottom: 20px;
          }

          strong.sublinhado{
            text-decoration: underline;
          }
        }
        .login-cadastro__form__group__button{
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        }
        .error-message {
          color: red;
          font-size: 12px;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>